import { getConnectUrl } from './get-connect-url';
import eventNames from '../common/event-names';
import { startListening } from './social-modal-listener';

const POPUP_WINDOW_NAME = 'SpotIMLogin';
const POPUP_WIDTH = 500;
const POPUP_HEIGHT = 400;

function openWindow(url) {
  var { innerWidth, innerHeight } = window;
  var left = parseInt((innerWidth - POPUP_WIDTH) / 2, 10);
  var top = parseInt((innerHeight - POPUP_HEIGHT) / 2.5, 10);
  var features = `width=${POPUP_WIDTH},height=${POPUP_HEIGHT},left=${left},top=${top}`;

  // IE9 does not like special characters in windowName argument. See http://stackoverflow.com/questions/9590282/script87-invalid-argument-in-ie-9-asp-net-c-sharp
  var newWindow = window.open(url, POPUP_WINDOW_NAME, features);
  if (newWindow) {
    newWindow.focus();
  }

  return newWindow;
}

function connect(socialNetwork, token, sourceUrl, { spotId, networkId }) {
  return new Promise(function(resolve) {
    var socialLoginWindow = null;
    const stopListening = startListening(handleMessage);
    function complete() {
      window.removeEventListener('message', handleMessage, false);
      stopListening();
      if (socialLoginWindow) {
        socialLoginWindow.close();
      }
    }

    function handleMessage(event) {
      var message = event.data;
      if (!message || !message.name) {
        return;
      }
      if (message.name === eventNames.LOGIN_EVENT && message.json) {
        resolve(message.json);
        complete();
        return;
      }
      if (message.name === eventNames.CANCELLED_EVENT) {
        complete();
        return;
      }
    }

    var url = getConnectUrl(socialNetwork, token, sourceUrl, { spotId, networkId });

    window.addEventListener('message', handleMessage, false);

    socialLoginWindow = openWindow(url);
  });
}

export async function socialLogin(
  socialNetwork,
  token,
  sourceUrl,
  { spotId = undefined, networkId = undefined }
) {
  var {
    complete_ticket: completeTicket,
    returning_user: isReturningUser,
    user_name: username,
    email: email
  } = await connect(
    socialNetwork,
    token,
    sourceUrl,
    { spotId, networkId }
  );

  return { completeTicket, isReturningUser, username, email };
}
